import { TilsynsobjektRowState } from "./types";

const initialState: TilsynsobjektRowState = {
      openRows: []
  };

  export default initialState;